module.exports = __webpack_public_path__ + "frontend/images/devise-singin-ad550b718fb381e730d6bbd386514fa5.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/devise-singin.jpg
// module id = 335
// module chunks = 2